import RatingLabel from './RatingLabel';

export default RatingLabel;
